import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import { MdDeleteOutline } from "react-icons/md";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../../../../store/userSlice";

export default function TableModeOfRequirement({
  modeOfRecruitments,
  setModeOfRecruitments,
  setData,
  titles = ["Sl No.", "Name", "Description", "Action"],
}) {
  const dispatch = useDispatch();
  const [deletedArrayList, SetDeletedArrayList] = useState([]);
  const DescriptionHandler = (id, value, field) => {
    const updatedMod = modeOfRecruitments.map((data) => {
      if (data?.id == id) {
        return {
          ...data,
          [field]: value,
        };
      }
      return data;
    });
    setModeOfRecruitments(updatedMod);
  };

  const DeleteHandler = (id) => {
    if (modeOfRecruitments.length > 1) {
      const updatedDescriptions = modeOfRecruitments.filter(
        (data) => data?.id != id
      );
      modeOfRecruitments.filter((data) => {
        if (data?.id == id) {
          if (data?.type !== "new") {
            SetDeletedArrayList((prev) => [
              ...prev,
              { mode_of_recruitment_id: data.id },
            ]);
          }
        }
      });
      setModeOfRecruitments(updatedDescriptions);
    } else {
      dispatch(
        setAppError({
          msg: "You are unable to delete the row as the table must contain at least one row ",
        })
      );
    }
  };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      mode_of_recruitment_delete: deletedArrayList,
    }));
  }, [deletedArrayList]);

  return (
    <>
      <div className="p-5  overflow-x-auto w-full">
        <div
          className={`grid justify-items-center drop-shadow-sm items-center grid-cols-4 space-x-5  auto-cols-min gap-5 p-6 bg-white  min-w-fit w-full rounded-md `}
        >
          {titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}
          {modeOfRecruitments.length <= 0 && (
            <div className="flex justify-center items-center  gap-3 mt-5 w-full col-span-4">
              <p>Loading</p>
              <CgSpinner className="animate-spin" />
            </div>
          )}

          {modeOfRecruitments?.map((list, index) => (
            <React.Fragment key={list?.id}>
              <p>{Number(index) + 1}</p>
              <input
                className="input input-sm input-bordered w-full"
                type="text"
                defaultValue={list?.name}
                required
                onChange={(e) =>
                  DescriptionHandler(
                    list?.id,
                    String(e.target.value).toUpperCase(),
                    "name"
                  )
                }
                placeholder="Enter name"
              />
              <textarea
                className="input border-slate-300 min-h-[60px] text-slate-600 leading-normal py-1  input-sm input-bordered w-full textTransformNone"
                type="text"
                name="description"
                onChange={(e) =>
                  DescriptionHandler(
                    list?.id,
                    String(e.target.value),
                    "description"
                  )
                }
                defaultValue={list?.description}
                required
                placeholder="Enter description"
              />

              {modeOfRecruitments.length > 1 ? (
                <div className="flex gap-3 min-w-fit ">
                  <button
                    type="button"
                    onClick={() => DeleteHandler(list?.id)}
                    className="p-1 px-2 rounded-md ring-1 ring-slate-300"
                  >
                    <MdDeleteOutline size={"1.4rem"} />
                  </button>
                </div>
              ) : (
                <div className="text-center">---</div>
              )}

              <hr
                className={
                  modeOfRecruitments.length > 1
                    ? "border-[1px] border-slate-100 bg-slate-100  w-full col-span-4"
                    : "hidden"
                }
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
}
